<template>
  <div>
    <Listbox
      :modelValue="topicDefault"
      :options="topics"
      optionLabel="label"
      @change="topicSelected"
      class="hidden md:block p-2 text-h-primary-500 listbox-custom gap-2"
    >
      <template #header>
        <h5 class="md:block text-h-neutral-900 !text-xl !medium pb-2">
          {{
            $t("labels.generic", {
              pt: "Explorar tópicos",
              en: "Explore topics",
            })
          }}
        </h5>
      </template>
    </Listbox>

    <Dropdown
      :options="topics"
      optionLabel="label"
      :modelValue="topicExplored"
      @change="topicSelected"
      class="md:!hidden w-full custom-dropdown"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "explore-topics",
  emits: ["topic-Selected"],
  data() {
    return {
      topics: [
        {
          label: this.$t("labels.generic", { pt: "Todos", en: "All" }),
          query: {},
          message: "",
        },
        {
          label: this.$t("labels.generic", {
            pt: "Não resolvidos",
            en: "Unsolved",
          }),
          query: { status: "ACTIVE" },
          message: this.$t("labels.generic", {
            pt: "não resolvido",
            en: "unsolved",
          }),
        },
        {
          label: this.$t("labels.generic", { pt: "Resolvidos", en: "Solved" }),
          query: { status: "SOLVED" },
          message: this.$t("labels.generic", { pt: "resolvido", en: "solved" }),
        },
        {
          label: this.$t("labels.generic", { pt: "Encerrados", en: "Closed" }),
          query: { status: "CLOSED" },
          message: this.$t("labels.generic", { pt: "encerrado", en: "closed" }),
        },
      ],
      topicDefault: this.topicExplored,
    };
  },
  props: { topicExplored: Object },
  methods: {
    topicSelected(event: any) {
      if (event.value !== null) {
        this.topicDefault = event.value;
        this.$emit("topic-Selected", event);
      }
    },
    initialTopicSelected() {
      const hasStatusAlreadySelected = this.topics.filter(
        (topic) => topic.query.status === this.$route.query.status
      );
      if (hasStatusAlreadySelected.length > 0) {
        return hasStatusAlreadySelected[0];
      }
      return {
        label: this.$t("labels.generic", { pt: "Todos", en: "All" }),
        query: {},
        message: "",
      };
    },
  },
  mounted() {
    this.topicDefault = this.initialTopicSelected();
  },
  watch: {
    topicExplored(value) {
      this.topicDefault = value;
    },
  },
});
</script>
